<template>
  <div class="hello"></div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      msg: 'Welcome to HistoPad Analytics app',
    }
  },
}
</script>
